import { createActions, createReducer } from "reduxsauce";

import Immutable from "seamless-immutable";
import { createSelector } from "reselect";

/*
Global application types and creators

https://github.com/skellock/reduxsauce#createactions

import { Types, Creators } from '../actions';

 */

export const { Types, Creators } = createActions({
  createRegistration: ["data"],
  registrationCreated: ["id"],
  updateRegistration: ["id", "data"],
  registrationUpdated: [],
  completeRegistration: ["id"],
  registrationCompleted: [],
  cancelRegistration: ["id"],
  registrationCanceled: [],

  beginRegistration: ["email"],
  setCurrentRegistration: ["registrationId"],
  stepComplete: ["step"],

  synchronizeRegistration: ["registrationId"],
  synchronizeStarted: [],

  saveQuestionnaireAnswer: ["questionnaire", "index", "answer"],

  saveContactInfo: ["registrationId", "contactInfo"],

  saveAddressInfo: ["registrationId", "contactInfo"],
});

/*
Initial State
 */
const initialState = Immutable({
  currentRegistrationId: localStorage.getItem("currentRegistrationId") || null,
});

const onBeginRegistration = (state = initialState, action) =>
  Immutable.merge(state, {
    isSearching: true,
  });

const onSetCurrentRegistration = (state = initialState, action) =>
  Immutable.merge(state, {
    currentRegistrationId: action.registrationId,
  });

const onCompleteRegistration = (state = initialState, action) =>
  Immutable.merge(state, {
    currentRegistrationId: null,
  });

const onCancelRegistration = (state = initialState, action) =>
  Immutable.merge(state, {
    currentRegistrationId: null,
  });

/*
Reducer
 */

export default createReducer(initialState, {
  [Types.BEGIN_REGISTRATION]: onBeginRegistration,
  [Types.SET_CURRENT_REGISTRATION]: onSetCurrentRegistration,
  [Types.COMPLETE_REGISTRATION]: onCompleteRegistration,
  [Types.CANCEL_REGISTRATION]: onCancelRegistration,
});

/*
Selectors

NOTE: Selectors are used within mapStateToProps so therefore have access to the
global state tree.
 */
const getRegistrations = (state) => state.data.registrations;
const getCurrentRegistrationId = (state) =>
  state.registration.currentRegistrationId;

export const getCurrentRegistration = createSelector(
  [getCurrentRegistrationId, getRegistrations],
  (currentRegistrationId, registrations) => {
    let currentRegistration = registrations[currentRegistrationId];

    if (!currentRegistration) {
      return null;
    }

    currentRegistration = {
      ...currentRegistration,
      minors: Object.values(currentRegistration.minors || {}),
    };

    return currentRegistration;
  }
);



// WEBPACK FOOTER //
// ./src/registration/reducer.js